import { render, staticRenderFns } from "./WorkoutRecoveryNotice.vue?vue&type=template&id=04b9770e&scoped=true"
import script from "./WorkoutRecoveryNotice.vue?vue&type=script&lang=js"
export * from "./WorkoutRecoveryNotice.vue?vue&type=script&lang=js"
import style0 from "./WorkoutRecoveryNotice.vue?vue&type=style&index=0&id=04b9770e&prod&scoped=true&lang=css"
import style1 from "./WorkoutRecoveryNotice.vue?vue&type=style&index=1&id=04b9770e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b9770e",
  null
  
)

export default component.exports